import { INSTITUTION, NAV_LINKS, LOGO_URL } from "../data/content";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1523] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-12 h-12 bg-white rounded-sm p-1">
                <img src={LOGO_URL} alt="Escudo UPP" className="w-full h-full object-contain" />
              </span>
              <span className="font-serif-display text-xl font-semibold leading-tight">
                {INSTITUTION.name}
              </span>
            </div>
            <p className="text-sm text-white/60 mt-5 max-w-xs leading-relaxed">
              {INSTITUTION.tagline}
            </p>
          </div>

          <div>
            <p className="text-xs uppercase tracking-overline text-white/40 mb-5">
              Navegación
            </p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-overline text-white/40 mb-5">
              Contacto
            </p>
            <ul className="space-y-3 text-sm text-white/70">
              <li>Carr. Pachuca – Cd. Sahagún km 20, Zempoala, Hidalgo, C.P. 43830</li>
              <li>(771) 547 75 10</li>
              <li>upp@upp.edu.mx</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-8 flex flex-col sm:flex-row justify-between gap-4">
          <p className="text-xs text-white/40">
            © {new Date().getFullYear()} {INSTITUTION.name}. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-white/40">
            Información institucional oficial.
          </p>
        </div>
      </div>
    </footer>
  );
};
